import { Volume } from 'tabler-icons-react';
import { SidebarStoryDetails, SongCard, StoryAccordionTitle } from 'Elements';
import styles from 'partials/story-box.module.scss';

export const StorySongs = ({ story, songs, isOpen, onBack, type }) => {
	return (
		<SidebarStoryDetails
			story={story}
			isOpen={isOpen}
			onBack={onBack}
			type={type}>
			<StoryAccordionTitle
				isOpen
				title="صوت ها"
				icon={Volume}
				hasExpand={false}
			/>
			<div className={styles.content}>
				{songs.map((song, idx) => {
					return (
						<SongCard key={`${song.file_id}_${idx}`} song={song} />
					);
				})}
			</div>
		</SidebarStoryDetails>
	);
};
